/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowParallelVIcon24Solid = forwardRef('ArrowParallelVIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M2.64 9.897A1.5 1.5 0 0 1 .52 7.775l3.927-3.927a2.906 2.906 0 0 1 4.11 0l3.928 3.927a1.5 1.5 0 1 1-2.121 2.122L8 7.535V19.5a1.5 1.5 0 1 1-3 0V7.535l-2.36 2.362Z" }),
        React.createElement("path", { d: "M19 16.465V4.5a1.5 1.5 0 0 0-3 0v11.965l-2.36-2.362a1.5 1.5 0 1 0-2.122 2.122l3.928 3.927a2.906 2.906 0 0 0 4.11 0l3.927-3.927a1.5 1.5 0 0 0-2.12-2.122L19 16.465Z" })));
});
